(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$(document.body).on('click', '[data-untarget]', function (e) {
		var st = $(document).scrollTop();

		e.preventDefault();

		window.location.hash = '#';

		$(document).scrollTop(st);

		if ('replaceState' in window.history) {
			window.history.replaceState('', document.title, window.location.pathname + window.location.search);
		}
	});
})();
